import React from 'react'
import Image from 'next/image'
import { helper } from '../../../utilities/helper'
import { resolveMediaPolicy } from './mediaPolicy'
import styles from './Media.module.scss'

const Media = ({
  src,
  picture,
  alt = '',
  policy,
  priority,
  quality,
  sizes,
  objectPosition = 'center',
  className = '',
  ratio = '16 / 9'
}) => {
  const resolvedSrc = picture ? helper.findImage(picture) : src
  const mediaPolicy = resolveMediaPolicy({ policy, priority, quality, sizes })

  if (!resolvedSrc) return <div className={`${styles.media} ${styles.placeholder} ${className}`.trim()} />

  return (
    <div
      className={`${styles.media} ${className}`.trim()}
      style={{ '--msr-media-ratio': ratio, '--msr-media-position': objectPosition }}
    >
      <Image
        src={resolvedSrc}
        alt={alt}
        fill
        priority={mediaPolicy.priority}
        quality={mediaPolicy.quality}
        sizes={mediaPolicy.sizes}
      />
    </div>
  )
}

export default Media
